import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Remove } from "../../../groups";

export const FETCH_DELETE_ACTOR_TYPES_REQUEST = 'FETCH_DELETE_ACTOR_TYPES_REQUEST';
export const FETCH_DELETE_ACTOR_TYPES_SUCCESS = 'FETCH_DELETE_ACTOR_TYPES_SUCCESS';
export const FETCH_DELETE_ACTOR_TYPES_FAILURE = 'FETCH_DELETE_ACTOR_TYPES_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDeleteActorTypesRequest = () => {
    return {
        type: FETCH_DELETE_ACTOR_TYPES_REQUEST,
    };
};

const fetchDeleteActorTypesSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DELETE_ACTOR_TYPES_SUCCESS,
        payload: data
    };
};

const fetchDeleteActorTypesFailure = (error: any) => {
    return {
        type: FETCH_DELETE_ACTOR_TYPES_FAILURE,
        payload: error,
    };
};

export const remove = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDeleteActorTypesRequest());
        try {
            await Remove(id);
            dispatch(fetchDeleteActorTypesSuccess(true));
        } catch (error: any) {
            dispatch(fetchDeleteActorTypesFailure(error.message));
        }
    };
};
